export default class IndividualCoach {
  constructor(
    id = null,
    days = [],
    user = null,
    trainer = null,
    program = null,
    Feedbacks = [],
    programs_history = [],
    questionnaire = null,
    notes = null,
    start_date= null,
    time = null,
    status = null,
    created = null
  ) {
    this.id = id;
    this.days = days;
    this.user = user;
    this.trainer = trainer;
    this.program = program;
    this.Feedbacks = Feedbacks;
    this.programs_history = programs_history;
    this.questionnaire = questionnaire;
    this.notes = notes;
    this.start_date= start_date;
    this.time = time;
    this.status = status;
    this.created = created;
  }
}